import { company_name } from "@/i18n/variables";

const configurator = {
	backup: {
		description: `<strong>Standard Backup</strong> 
			<ul>
				<li>A daily backup that is kept for 2 days.</li>
				<li>A weekly backup that is kept for 2 weeks.</li>
				<li>A monthly backup that is kept for 1 month.</li>
			</ul>
			
			<strong>Extra Backups</strong> 
			<ul>
				<li>4 backups per day, one of which is kept for 7 days.</li>
				<li>A weekly backup that is kept for 4 weeks.</li>
				<li>A monthly backup that is kept for 6 months.</li>
			</ul>`,
		radio: {
			extra_backups: {
				label: "Extra Backups",
				tip: "4 backups are made per day. One daily backup is kept for 7 days, one weekly backup for 4 weeks, and one monthly backup for 6 months.",
			},
			standard: {
				label: "Standard",
				tip: "<A daily backup is made once a day, which we keep for 2 days. One weekly backup is kept for 2 weeks and one monthly backup for 1 month.",
			},
		},
		title: "Backup",
	},
	config_lower_then_template:
		"The set {{label}} is {{configuration_value}} {{unit_type}}, while the operating system recommends at least {{template_value}} {{unit_type}}. This may lead to performance issues.",
	configurator_overview: {
		cancel_concept_order_error: "We couldn't cancel the draft order. Please try again later.",
		change_vps: "Change Your VPS",
		confirm_new_vps: "Overview of New VPS",
		excl_vat: "Excl. VAT",
		form: {
			description: {
				label: "VPS Description",
				placeholder: "Notes/special features of VPS",
			},
			name: {
				label: "VPS Name",
				placeholder: "",
			},
			purchase_order_number: {
				label: "Your Purchase Order Number",
				placeholder: "Your optional purchase order number",
			},
		},
		info: "The data traffic of your new VPS will be calculated within your account pool. For more information, go to",
		license: "License",
		new_price: "New Configuration Price",
		new_vps: "Operating System/Application",
		old_price: "You paid",
		price_total: "Total Price",
		vps_configuration: {
			description: "Overview of your new VPS.",
			title: "VPS Configuration",
		},
		vps_details: {
			description: "You can still change this here if necessary.",
			title: "VPS Details",
		},
		your_discount: "Your discount",
		your_vps: "Operating System/Application",
	},
	details: {
		description:
			"Give the VPS a clear name (no special characters). You can optionally add a description to the VPS.",
		inputs: {
			description: "VPS Description",
			name: "VPS Name",
		},
		title: "VPS Name",
	},
	extra_storage: {
		bulk_storage: {
			description:
				"This storage is ideal for backup data, archiving and data for non-critical services. <strong>No backups </strong> are made of this storage.",
			title: "Bulk",
		},
		description:
			"Here, additional storage can be added to the VPS for various purposes. \n Tick the desired storage option.",
		no_storage: "No Storage",
		performance_storage: {
			description: "Text still needs to be written here!!! T.B.D",
			title: "Performance",
		},
		title: "Additional storage",
	},
	footer: {
		actual_price: "Actual Price",
		configuration_check: "Check Configuration",
		configuration_price: "Configuration Price",
		discount_price: "Your Price",
		month: "Month",
		order_title: "Order",
	},
	internet: {
		description: {
			href: "https://www.tuxis.nl/en/network",
			text: `Choose between <strong>IPv6</strong> or <strong>IPv4 & IPv6</strong>.<br/>Only traffic leaving the Tuxis network will be deducted from your network pool. Haven't chosen a pool yet? Then we use option one: 100 GB as mentioned at <a>tuxis.nl/network</a>.`,
		},
		radio: {
			ipv4: "IPv4 and IPv6",
			ipv6: "IPv6 Only",
			no_internet: "No Internet Connection",
		},
		title: "Internet Connection",
	},
	private_networks: {
		description:
			"Connect VPSs to each other using a private network. The VPS gets a separate network interface for this. VPSs in the same network can communicate with each other. You only need to configure IP addresses on this internal interface.",
		existing: {
			select: {
				label: "Private Network",
				list: "Select a network",
			},
			title: "Select an Existing Private Network",
		},
		new: {
			input: {
				description: "Network Description",
				name: "Network Name",
			},
			title: "New Private Network",
		},
		radio: {
			existing_private_network: "Existing Private Network",
			new_private_network: "New Private Network",
			no_private_network: {
				label: "No Private Network",
				tip: "The VPS comes with an internet interface for internet access.",
			},
		},
		title: "Private Networks",
	},
	sla: {
		description: {
			href: "https://tuxis.nl/en/sla",
			text: "Turn your VPS into a fully managed VPS. An SLA - level 1 monitors system health 24x7 and an SLA - level 2 even monitors if your application responds. Half an hour of work on this VPS is included, and you can count on guaranteed response times. See <a>tuxis.nl/en/sla</a> for the full SLA.",
		},
		radio: {
			level_one: {
				label: "SLA - Level 1",
				tip: `<strong>SLA - Level 1</strong> 
					<ul>
						<li>Monitoring system health</li>
						<li>Start fixing malfunctions within one hour</li>
						<li>Run updates once a month</li>
						<li>Important security updates immediately</li>
						<li>Half an hour of work on this VPS</li>
						<li>24x7 intervention in case of malfunctions</li>
					</ul>
				`,
			},
			level_two: {
				label: "SLA - Level 2",
				tip: `<strong>SLA - Level 2</strong> 
					<ul>
						<li>Monitoring system health</li>
						<li>Start fixing malfunctions within one hour</li>
						<li>Run updates once a month</li>
						<li>Important security updates immediately</li>
						<li>Half an hour of work on this VPS</li>
						<li>Monitoring of services and results</li>
						<li>24x7 intervention in case of malfunctions or service failures</li>
					</ul>
				`,
			},
			level_zero: {
				label: "SLA - Level 0",
			},
			no_sla: "None",
		},
		title: "Service Level Agreement",
	},
	snapshots: {
		description:
			"Snapshots are handy to create when you are going to do an update. You determine how many you can keep at once.",
		no_snapshots: {
			info: "You can only choose this if <strong>all</strong> snapshots have been cleared.",
			label: "None",
		},
		select_amount: {
			info: "There are currently <strong>{{snapshots}}</strong> {{multiple}} made. So you can scale down to a maximum of <strong>{{snapshots}}</strong> {{multiple}}.",
			label: "Snapshots",
		},
		title: "Snapshots",
	},
	specs: {
		cpu: {
			title: "CPU Cores",
		},
		info: "For larger configurations, please contact us.",
		license: "<span>License:</span> €{{price}} per month",
		ram: {
			title: "Memory",
		},
		ssd: {
			title: "SSD Storage",
			tooltip:
				"Your data is continuously written in real-time to three data centers on SSDs. The more CPU cores you put in the VPS, the higher the number of IOPS. LINK to IOPS at https://support.tuxis.nl/en/knowledgebase/article/iops-vps.",
		},
		title: "VPS capacity",
	},
	ssh: {
		add_engineer_keys: {
			no: "No",
			title: `Do you want to give ${company_name} access to your VPS via SSH?`,
			yes: "Yes, grant access",
		},
		add_own_keys: {
			no: "No",
			success: "SSH key added to your account",
			title: "Do you want to use your personal public SSH key(s)?",
			yes: "Yes",
		},
		already_present:
			"SSH key not added: The new SSH key is exactly the same as an SSH key that has already been added.",
		description:
			"Select which users (with SSH keys) can access the VPS, and/or manually add SSH keys. <strong>No password</strong> will then be created. So make sure that the SSH port remains accessible. If you do not add SSH keys, a password will be created with which you can log in. This password can be found on the VPS info page, where it will be displayed for 30 days (so save this password carefully!).",
		engineer_keys_obliged: `Because you have selected an SLA, ${company_name} must have access to your VPS.`,
		external_keys: "Do you want to add additional SSH keys from an external party?",
		no_own_keys_top: "You have not added SSH keys to your account.",
		title: "VPS Access",
		user_ssh_keys: {
			no_users_found: "No users with SSH keys found.",
			title: "Adding SSH keys from other users",
			users: "Users",
		},
	},
	template_items_disabled_message:
		"One or more configuration options for this VPS template have been disabled by Tuxis. These disabled configuration options cannot be modified.",
	title: "VPS Configurator",
};

export default configurator;
